import React from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';

const DefaultNode = ({ data, selected }) => {
    return (
        <div className="default-node" style={{ position: 'relative', padding: '0px' }}>
            <NodeResizer isVisible={selected} /> {/* Enable resizing */}
            <div className="resizable-node">
                {data.label}
            </div>
            <Handle type="source" position={Position.Right} />
            <Handle type="target" position={Position.Left} />
        </div>
    );
};

export default DefaultNode;